import React, { useEffect, useState } from "react";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Strings from "../commons/string";
import * as Common from "../commons/common";
import * as Utils from "../utils/utils";

import { Button, Col, Row, Form, Space, Input, Divider, Select, Modal, Checkbox } from "antd";

import styles from "../pages/RentInfo.module.css";
import { useAsyncAxios, utilAxiosWithAppToken, utilAxiosWithAuth } from "../utils/customAxios";
import moment from "moment";
import ModalChangeRentCar from "./ModalChangeRentCar";
import ModalAddPaidItems from "./ModalAddPaidItems";
import TextArea from "antd/es/input/TextArea";

function RentDetail({
    rent,
    onUseRent,
    onChangeRentCar,
    onChangeRentMemo,
    onUpdatePaidItem,
}: {
    rent: Types.RentDto;
    onUseRent?: (rent: Types.RentDto) => void;
    onChangeRentCar?: (rent: Types.RentDto, rentCarId: number) => void;
    onChangeRentMemo?: (rent: Types.RentDto, memo: string) => void;
    onUpdatePaidItem?: (rent: Types.RentDto, paidItemIds: Array<number>, payments?: Array<Types.RentPaidItemDto>) => void;
}) {
    const [inputType, setInputType] = useState<boolean>(false);
    const [form] = Form.useForm();
    // const [user, setUser] = useState<Types.UserDto>();
    const [strDelayedTime, setStrDelayedTime] = useState<string | undefined>();
    const [openModalAddPaidItem, setOpenModalAddPaidItem] = useState(false);
    const [tempMemo, setTempMemo] = useState("");

    const [changableRentCarList, setChangableRentCarList] = useState<Array<Types.RentCarDto>>([]);
    const [openModalChangeRentCar, setOpenModalChangeRentCar] = useState(false);
    const [selectedChangeRent, setSelectedChangeRent] = useState<Types.RentDto>();

    useEffect(() => {
        Utils.onEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        return () => {
            Utils.offEvent(Common.EVENT_CLOSE_ALL_MODAL, handleCloseAllModal);
        };
    }, []);

    const handleCloseAllModal = () => {
        Modal.destroyAll();
        setOpenModalAddPaidItem(false);
        setOpenModalChangeRentCar(false);
    };

    useEffect(() => {
        if (rent) {
            form.setFieldsValue(rent);
            // requestGetUser(rent.user.email);

            setDelayedTime(rent);

            setTempMemo(rent.memo ? rent.memo : "");
        }
    }, [rent]);

    const setDelayedTime = (rentData: Types.RentDto) => {
        if (rentData.arrivedDate === null || rentData.arrivedDate === undefined) {
            setStrDelayedTime(undefined);
            return;
        }

        const originalArrivedDate = moment(rentData.endDate + Common.DEFAULT_ARRIVED_TIME);
        const realArrivedDate = moment(Utils.utcToLocalTime(rent.arrivedDate, Common.FORMAT_DATE_TIME));

        const hour = realArrivedDate.diff(originalArrivedDate, "hours");
        const minute = realArrivedDate.diff(originalArrivedDate, "minutes") % 60;

        if (minute > 0 || hour > 0) {
            setStrDelayedTime((hour > 0 ? String(hour) + "시간 " : "") + (minute > 0 ? String(minute) + "분" : "") + " 지연");
        } else {
            setStrDelayedTime(undefined);
        }
    };

    // const requestAxiosGetUser = async (email: string) => {
    //     const response = await utilAxiosWithAuth().get(Request.USER_URL + email);
    //     return response.data;
    // };

    // const { loading: loadingGetUser, error: errorGetUser, data: resultGetUser, execute: requestGetUser } = useAsyncAxios(requestAxiosGetUser);

    // useEffect(() => {
    //     if (resultGetUser === null) return;
    //     console.log("resultGetUser", resultGetUser);
    //     setUser(resultGetUser.user);
    // }, [resultGetUser]);

    // useEffect(() => {
    //     if (errorGetUser === null) return;
    //     console.log("errorGetUser", errorGetUser);
    // }, [errorGetUser]);

    const changeRentCar = (rent: Types.RentDto) => {
        setOpenModalChangeRentCar(true);
        setSelectedChangeRent(rent);
    };

    useEffect(() => {
        selectedChangeRent && requestGetChangeRentCars(selectedChangeRent);
    }, [selectedChangeRent]);

    const requestAxiosGetChangeRentCars = async (rent: Types.RentDto) => {
        const response = await utilAxiosWithAuth().get(Request.RENT_CARS_ALL_URL, {
            params: {
                rentRegionId: rent.rentCar.rentRegion.rentRegionId,
            },
        });
        return response.data;
    };

    const {
        loading: loadingGetChangeRentCars,
        error: errorGetChangeRentCars,
        data: resultGetChangeRentCars,
        execute: requestGetChangeRentCars,
    } = useAsyncAxios(requestAxiosGetChangeRentCars);

    useEffect(() => {
        if (resultGetChangeRentCars === null) return;
        console.log("resultGetChangeRentCars", resultGetChangeRentCars);
        setChangableRentCarList(
            resultGetChangeRentCars.rentCars.filter((rentCar: Types.RentCarDto) => rentCar.car.carNumber !== selectedChangeRent?.rentCar.car.carNumber)
        );
    }, [resultGetChangeRentCars]);

    useEffect(() => {
        if (errorGetChangeRentCars === null) return;
        console.log("errorGetChangeRentCars", errorGetChangeRentCars);
    }, [errorGetChangeRentCars]);

    const onAddPaidItems = () => {
        setOpenModalAddPaidItem(true);
    };

    return (
        <div>
            <Space direction="vertical" size={10} style={{ width: "100%" }}>
                <Form form={form} layout="inline">
                    <Row style={{ border: "solid 1px #DBDFE5" }}>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" name="createdDate" label="예약일시">
                                <span>{rent.createdDate ? Utils.utcToLocalTime(rent.createdDate, Common.FORMAT_SIMPLE_DATE_TIME) : Strings.dash}</span>
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" name={["rentCar", "car", "carType", "typeName"]} label="차량">
                                <span>
                                    {rent.rentCar?.car?.carType?.typeName || Strings.dash}_{" "}
                                    {rent?.rentCar?.title?.includes("★") ? "[특가]" : rent.rentCar.b2b ? "[B2B]" : ""}
                                    {rent.rentCar?.car?.carNumber || Strings.dash}
                                </span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" label="대체차량">
                                <Row align={"middle"} justify={"space-between"}>
                                    <span style={{ fontSize: 16 }}>{rent.usedRentCar?.car?.carNumber ? rent.usedRentCar?.car?.carNumber : Strings.dash}</span>
                                    <Button onClick={() => changeRentCar(rent)}>변경</Button>
                                </Row>
                            </Form.Item>
                            <Form.Item className="searchForm" name="checkedUsagePolicy" label="이용 안내 확인">
                                <Checkbox disabled checked={rent.checkedUsagePolicy}>
                                    <span style={{ color: rent.checkedUsagePolicy ? "" : "red" }}>
                                        {`사전 체크 ${rent.checkedUsagePolicy ? "완료" : "미완료"} 상태`}
                                    </span>
                                </Checkbox>
                            </Form.Item>
                            <Form.Item className="searchForm" name="checkedExitPolicy" label="출차 안내 확인">
                                <Checkbox disabled checked={rent.checkedExitPolicy}>
                                    <span style={{ color: rent.checkedExitPolicy ? "" : "red" }}>
                                        {`사전 체크 ${rent.checkedExitPolicy ? "완료" : "미완료"} 상태`}
                                    </span>
                                </Checkbox>
                            </Form.Item>
                        </Col>

                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm searchLastRow" label="유료대여">
                                <Row align={"middle"} justify={"space-between"}>
                                    {rent.rentPaidItems.length > 0 ? (
                                        rent.rentPaidItems.map((item: Types.RentPaidItemDto) => {
                                            const createdDate = rent.rentPayments.find(
                                                (pay) => pay?.rentPaymentItem?.rentPaymentItemName === item.rentPaidItemName
                                            )?.createdDate;
                                            return (
                                                <span
                                                    key={item.rentPaidItemId}
                                                    style={{ fontSize: 16 }}
                                                    className={createdDate && moment(createdDate).isAfter(moment(rent.createdDate)) ? styles.paidItems : ""}
                                                >
                                                    {item.rentPaidItemName}
                                                </span>
                                            );
                                        })
                                    ) : (
                                        <span style={{ fontSize: 16 }}>-</span>
                                    )}
                                    <Button onClick={onAddPaidItems}>{rent.rentPaidItems === null || rent.rentPaidItems.length === 0 ? "추가" : "변경"}</Button>
                                </Row>
                            </Form.Item>
                        </Col>
                    </Row>

                    <Row style={{ border: "solid 1px #DBDFE5", marginTop: 10 }}>
                        <Col xs={{ span: 24 }}>
                            <Form.Item className="searchForm" name="status" label="예약상태">
                                {rent ? (
                                    rent.rentStatus === "DURING_PAYMENT" ? (
                                        <span style={{ color: "red" }}>{Utils.getRentStatus(rent)}</span>
                                    ) : (
                                        <span>{Utils.getRentStatus(rent)}</span>
                                    )
                                ) : (
                                    <span>Strings.dash</span>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" name="usedDate" label="출차시간">
                                <span>{rent.usedDate ? Utils.utcToLocalTime(rent.usedDate, Common.FORMAT_SIMPLE_DATE_TIME) : Strings.dash}</span>
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm" name="arrivedDate" label="반납시간">
                                {rent.arrivedDate ? (
                                    <Row style={{ fontSize: 16 }} justify={"space-between"}>
                                        {Utils.utcToLocalTime(rent.arrivedDate, Common.FORMAT_SIMPLE_DATE_TIME)} {strDelayedTime && strDelayedTime}
                                    </Row>
                                ) : (
                                    <span>{Strings.dash}</span>
                                )}
                            </Form.Item>
                        </Col>
                        <Col xs={{ span: 24 }} sm={{ span: 12 }}>
                            <Form.Item className="searchForm searchLastRow" name="memo" label="기타">
                                <Space>
                                    <TextArea
                                        autoSize={{ minRows: 2, maxRows: 2 }}
                                        placeholder="렌트 관련 메모 입력란입니다."
                                        value={tempMemo}
                                        onChange={(e) => setTempMemo(e.target.value)}
                                    ></TextArea>
                                    <Button disabled={!tempMemo} onClick={() => onChangeRentMemo && onChangeRentMemo(rent, tempMemo)}>
                                        수정
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Space>

            <ModalChangeRentCar
                rentCars={changableRentCarList}
                open={openModalChangeRentCar}
                onChangedOpen={(open: boolean) => {
                    setOpenModalChangeRentCar(open);
                }}
                onChangedRentCar={(rentCarId) => {
                    selectedChangeRent && onChangeRentCar && onChangeRentCar(selectedChangeRent, rentCarId);
                    setOpenModalChangeRentCar(false);
                }}
            />

            <ModalAddPaidItems
                paidItems={rent.rentPaidItems}
                open={openModalAddPaidItem}
                onChangedOpen={(open: boolean) => {
                    setOpenModalAddPaidItem(open);
                }}
                onAddPaidItems={(paidItems, payments) => {
                    setOpenModalAddPaidItem(false);
                    onUpdatePaidItem &&
                        onUpdatePaidItem(
                            rent,
                            paidItems.map((paidItem) => paidItem.rentPaidItemId),
                            payments
                        );
                }}
            />
        </div>
    );
}

export default RentDetail;
